import * as React from 'react';
import { useDispatch } from 'react-redux';

import { getFioSuggest } from '../../../actions/suggest';
import { EPartsLower, EGender, TGetFIOSuggest } from '../../../types/fio';
import { TThunkDispatch } from '../../../types/redux';

export function useGetFIOSuggest() {
  const dispatch = useDispatch<TThunkDispatch>();

  return React.useCallback(
    (query: string, currentPartFIO: EPartsLower, gender: EGender) => {
      return dispatch(getFioSuggest(query, currentPartFIO, gender));
    },
    [dispatch],
  ) as unknown as TGetFIOSuggest;
}
